import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "ReadingPaneOptions" */ './lazyIndex'),
    { name: 'ReadingPaneOptions' }
);

export const lazySaveReadingPaneOption: LazyAction<
    typeof lazyIndex.saveReadingPaneOptionQuick,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.saveReadingPaneOptionQuick);
export { saveReadingPanePositionOption } from './actions/saveReadingPanePositionOption';
